import React, { useState } from 'react';

import { Button } from '@mui/material';

import { FRAUD_STATUS, PATCH_UPDATE_FRAUD_STATUS } from '~/consts/order';

import { updateOrder } from '~/services/OrdersService';

interface Props {
  order: App.Order;
  allOrders: Array<App.Order>;
  onOrdersUpdated?: (updatedOrders: Array<App.Order>) => void;
}

export function MarkForwardFraud({ order, allOrders, onOrdersUpdated }: Props) {
  const [isUpdating, setIsUpdating] = useState(false);

  const handleClick = async () => {
    const confirmed = window.confirm(
      `Are you sure you want to mark order #${order.id} and all future orders as fraud? This action cannot be undone.`,
    );
    if (!confirmed) {
      return;
    }

    setIsUpdating(true);

    try {
      // Find all orders from this one forward (same or later created_at timestamp)
      const currentOrderDate = new Date(order.created_at);
      const futureOrders = allOrders.filter((o) => new Date(o.created_at) >= currentOrderDate);

      // Update all future orders
      const updatePromises = futureOrders.map((futureOrder) =>
        updateOrder(futureOrder.id, {
          op: PATCH_UPDATE_FRAUD_STATUS,
          fraudStatus: FRAUD_STATUS.MANUAL_REVIEWED_FRAUD,
        }),
      );

      await Promise.all(updatePromises);

      // Create updated orders array
      const updatedOrders = allOrders.map((o) => {
        if (new Date(o.created_at) >= currentOrderDate) {
          return {
            ...o,
            fraud_status: FRAUD_STATUS.MANUAL_REVIEWED_FRAUD,
          };
        }
        return o;
      });

      // Call the callback to update the parent component's state
      if (onOrdersUpdated) {
        onOrdersUpdated(updatedOrders);
      }

      alert(`${futureOrders.length} orders have been marked as fraud.`);
    } catch (error) {
      console.error('Failed to update orders fraud status:', error);
      alert('Error updating orders fraud status, try again');
    } finally {
      setIsUpdating(false);
    }
  };

  return (
    <Button variant="outlined" size="small" onClick={handleClick} disabled={isUpdating} sx={{ mt: 1, ml: 1 }}>
      {isUpdating ? 'Updating...' : 'Mark here forward as fraud'}
    </Button>
  );
}
